import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import api from '../../api/api'

export const get_admin_dashboard_data = createAsyncThunk(
  'dashboard/get_admin_dashboard_data',
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get('/admin/get-dashboard-data', {
        withCredentials: true,
      })
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End method

export const get_seller_dashboard_data = createAsyncThunk(
  'dashboard/get_seller_dashboard_data',
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get('/seller/get-dashboard-data', {
        withCredentials: true,
      })
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End method

export const add_currency = createAsyncThunk(
  'dashboard/add_currency',
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post('/add-currency', info, {
        withCredentials: true,
      })
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const get_currency = createAsyncThunk(
  'dashboard/get_currency',
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get('/get-currency', {
        withCredentials: true,
      })
      //  console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const update_currency = createAsyncThunk(
  'dashboard/update_currencu',
  async (
    { currencyId, currencyUSD, currencyIQD, createdAt },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.put(
        `/update-currency/${currencyId}`,
        { currencyUSD, currencyIQD, createdAt },
        {
          withCredentials: true,
        }
      )

      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const get_currencyIQD = createAsyncThunk(
  'dashboard/get_currencyIQD',
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get('/get-currencyIQD', {
        withCredentials: true,
      })
      //  console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const dashboardReducer = createSlice({
  name: 'dashboard',
  initialState: {
    successMessage: '',
    errorMessage: '',
    totalSale: 0,
    totalOrder: 0,
    totalProduct: 0,
    totalPendingOrder: 0,
    totalUser: 0,
    requestUser: 0,
    recentOrder: [],
    recentMessage: [],
    currency: '',
    currencyIQD: 0,
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = ''
      state.successMessage = ''
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(get_admin_dashboard_data.fulfilled, (state, { payload }) => {
        state.totalSale = payload.totalSale
        state.totalOrder = payload.totalOrder
        state.totalProduct = payload.totalProduct
        state.totalUser = payload.totalUser
        state.requestUser = payload.requestUser
        state.recentOrder = payload.recentOrders
        state.recentMessage = payload.messages
      })
      .addCase(get_seller_dashboard_data.fulfilled, (state, { payload }) => {
        state.totalSale = payload.totalSale
        state.totalOrder = payload.totalOrder
        state.totalProduct = payload.totalProduct
        state.totalPendingOrder = payload.totalPendingOrder
        state.recentOrder = payload.recentOrders
        state.recentMessage = payload.messages
      })
      .addCase(add_currency.fulfilled, (state, { payload }) => {
        state.loader = false
        state.currency = payload.currency
        state.successMessage = payload.message
      })
      .addCase(get_currency.fulfilled, (state, { payload }) => {
        state.currency = payload.currency
      })
      .addCase(update_currency.fulfilled, (state, { payload }) => {
        state.loader = false
        state.currency = payload.currency
        state.successMessage = payload.message
      })
       .addCase(get_currencyIQD.fulfilled, (state, { payload }) => {
              state.currencyIQD = payload.currencyIQD
            })
  },
})
export const { messageClear } = dashboardReducer.actions
export default dashboardReducer.reducer
